import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.786 3.77a12.54 12.54 0 0 0-12.965-.865.25.25 0 0 1-.292-.045L1.937.269A.51.51 0 0 0 1.392.16a.5.5 0 0 0-.308.462v6.7a.5.5 0 0 0 .5.5h6.7a.5.5 0 0 0 .354-.854L6.783 5.115a.25.25 0 0 1-.068-.228.25.25 0 0 1 .152-.181 10 10 0 0 1 9.466 1.1 9.76 9.76 0 0 1 .094 15.809 1.25 1.25 0 0 0 1.473 2.016 12.12 12.12 0 0 0 5.013-9.961 12.13 12.13 0 0 0-5.127-9.9" }, null, -1)
  ]))]))
}
export default { render: render }